/* eslint-disable array-callback-return */
import React from "react";
import { useTranslation } from "react-i18next";
import { ViedocButtonElement } from "../../../../../secure/elements/ViedocReactElements";
import { useDispatch, useSelector } from "react-redux";
import * as documentActions from "../../../../../store/actions/documentActions";
import * as UtilsHelper from "../../../../../../utils/utilsHelper";

const NewBinderConfirmation = ({
  setShowSharedForm,
  setshowNewBinderConfirmation,
  formData,
  docDetail,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { countrySiteList } = useSelector((store) => store.zone);
  const recipientNamesWithRole =
    formData.userType === "Subjects"
      ? formData.subjectList
          .map((user) => user.displayNamewithrole)
          .join(", ")
          .toString()
      : formData.clinicalUserList
          .map((user) => user.displayNamewithrole)
          .join(", ")
          .toString();

  const cosignatoryNamesWithRole = formData.coSignatoriesList
    .map((user) => user.displayNamewithrole)
    .join(", ")
    .toString();

  const binderConfirmAction = () => {
    let recipientstype =
      formData.userType === "Clinical User" ? "clinicaluser" : "subject";
    let recipients = [];
    formData.userType === "Clinical User"
      ? formData.clinicalUserList.map((recipi) => {
          let rolename = [];
          rolename.push(recipi.rolegroupname);
          recipients.push({
            userid: recipi.guid,
            userlanguage: recipi.userlanguage,
            rolename: rolename,
            sitesid: recipi.siteid,
            studyscope: recipi.studyScope,
            displayName: recipi.value,
            sitename: recipi.sitename,
          });
        })
      : formData.subjectList.map((recipi) => {
          recipients.push({
            userid: recipi.guid,
            userlanguage: recipi.userlanguage,
            sitename: recipi.sitename,
            sitesid: recipi.siteid,
            studyscope: recipi.studyScope,
            displayName: recipi.value,
            accountInitiationCompleted: recipi.accountInitiationCompleted,
          });
        });
    let cosignatories = [];
    formData.coSignatoriesList.length !== 0 &&
      formData.coSignatoriesList.map((user) => {
        let rolename = [];
        rolename.push(user.rolegroupname);
        cosignatories.push({
          userid: user.guid,
          userlanguage: user.userlanguage,
          rolename: rolename,
          sitesid: user.siteid,
          studyscope: user.studyScope,
          displayName: user.value,
          sitename: user.sitename,
        });
      });
    let emailGuid = countrySiteList.site && countrySiteList.site[0].id;
    let createBinderPayload = {
      documentid: docDetail.documentid,
      documentversionid: docDetail.documentversionguid,
      recipientstype: recipientstype,
      recipients: recipients,
      createseparatebinderforrecipients: formData.isCreateBinderSeperate,
      requiredsignature: formData.isRequestForSignature,
      signaturereason: formData.signatureReason.value,
      requiredcosingnatory: formData.isToAddCoSignatory,
      cosignatories: cosignatories,
      cosingnatorysignaturereason: formData.coSignatoriesReason.value,
      currentdocumentsystemversion: docDetail.documentsystemversion,
      displayname: docDetail.displaytemplate,
      emailsiteguid: emailGuid,
    };

    createBinderPayload.fileInfo = {
      fileintegrity: docDetail.fileintegrity,
      fileguid: docDetail.documentguid,
      originalfilename: docDetail.origfilename,
      fileextension: docDetail.type,
    };

    dispatch(
      documentActions.createBinderDetailsForSharing(createBinderPayload)
    );
    setshowNewBinderConfirmation(false);
    setShowSharedForm(false);
  };

  const renderButtonSection = () => {
    return (
      <div className="button-section">
        <ViedocButtonElement
          size="small"
          variant="neutral"
          onClick={() => setshowNewBinderConfirmation(false)}
        >
          <viedoc-icon
            name="arrow"
            slot="prefix"
            class="left-arrow"
          ></viedoc-icon>
          {t("TMF.BUTTON_BACK")}
        </ViedocButtonElement>
        <ViedocButtonElement
          size="small"
          variant="success"
          onClick={() => binderConfirmAction()}
        >
          {t("TMF.BUTTON_CONFIRM")}
        </ViedocButtonElement>
      </div>
    );
  };
  const renderInfoSection = () => {
    return (
      <div className="info-section">
        <div className="info">
          <p>
            {`${t("TMF.TEXT_HASHOFNEWBINDERS")}:`}
            <span>1</span>
            <span className="pipe">|</span>
          </p>
          <p>
            {`${t("TMF.TEXT_HASHOFRECIPIENT")}:`}
            <span>
              {formData.userType === "Subjects"
                ? formData.subjectList.length
                : formData.clinicalUserList.length}
            </span>
            <span className="pipe">|</span>
          </p>
          <p>
            {`${t("TMF.TEXT_SIGNATUREREQUIRED")}:`}
            <span>
              {formData.isRequestForSignature
                ? t("ADMIN.DELETEDOCUMENT_YES")
                : t("ADMIN.DELETEDOCUMENT_NO")}
            </span>
            <span className="pipe">|</span>
          </p>
          {formData.isToAddCoSignatory && (
            <p>
              {`${t("TMF.TEXT_HASHOFCOSIGNATORY")}:`}
              <span>{formData.coSignatoriesList.length}</span>
            </p>
          )}
        </div>
        <div className="recipient-info">
          <p>{`${t("TMF.LABEL_RECIPIENTS")}:`}</p>
          <p className="sem-pri-color">{recipientNamesWithRole}</p>
          {formData.isRequestForSignature && (
            <>
              <p>{`${t("TMF.TEXT_REASONFORSIGNATURE")}:`}</p>
              <p className="sem-pri-color">
                {t(
                  `TMF.${UtilsHelper.getSignReasonTranslateKey(
                    formData.signatureReason.value
                  )}`
                )}
              </p>
            </>
          )}
        </div>
        {formData.isToAddCoSignatory && (
          <div className="recipient-info">
            <p className="gray-60">{`${t("TMF.LABEL_COSIGNATORY")}:`}</p>
            <p className="sem-pri-color">{cosignatoryNamesWithRole}</p>
            <p className="gray-60">{`${t(
              "TMF.TEXT_REASONFORCOSIGNATURE"
            )}:`}</p>
            <p className="sem-pri-color">
              {t(
                `TMF.${UtilsHelper.getSignReasonTranslateKey(
                  formData.coSignatoriesReason.value
                )}`
              )}
            </p>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="new-binder-main-section">
      <div className="confirmation-page">
        {renderInfoSection()}
        {renderButtonSection()}
      </div>
    </div>
  );
};

export default NewBinderConfirmation;
